// api error code and its description mapping
export const ERROR_CODES = {
  InvalidLoginAttempt: 'Incorrect email or password',
  ServerError: 'Failed to perform action, Please try after sometime',
  IncorrectOTP: 'Invalid OTP entered',
  InvalidPhoneEntered: 'Invalid number',
  NoValidAccounts: 'Incorrect email or password',
  PasswordIncorrect: 'Current password is incorrect',
  ExistingPasswordReused: 'Can\'t reuse current password',
  AccountInviteNotFound: 'The invite code has either expired or is invalid',
  InvalidEmail: 'The email you entered is not a valid email address.',
  InvalidInviteCode: 'Invalid invite code',
  EmailAlreadyExists:
    'The email you entered already exists, Perhaps you meant to Sign In',
  InvalidPassword: 'You cannot use that password. Please try another password.',
  GenericSignUpError: 'Error signing up. Please try again.',
  InvalidResetId: 'Reset password link is expired',
  UserDoesNotExists: 'User does not exists',
  UserAlreadyExists: 'User already exists',
  InvalidReferrerEmail: 'Invalid Referrer Email',
} as const;

export const ERROR_CODES_KEYS = {
  'Incorrect email or password': 'Incorrect_email_or_password',
  'Failed to perform action, Please try after sometime':
    'Failed_to_perform_action_Please_try_after_sometime',
  'Invalid OTP entered': 'Invalid_OTP_entered',
  'Invalid number': 'Invalid_number',
  'Current password is incorrect': 'Current_password_is_incorrect',
  'Can\'t reuse current password': 'Can\'t_reuse_current_password',
  'The invite code has either expired or is invalid':
    'The_invite_code_has_either_expired_or_is_invalid',
  'The email you entered is not a valid email address.':
    'The_email_you_entered_is_not_a_valid_email_address',
  'Invalid invite code': 'Invalid_invite_code',
  'The email you entered already exists, Perhaps you meant to Sign In':
    'The_email_you_entered_already_exists_Perhaps_you_meant_to_Sign_In',
  'You cannot use that password. Please try another password.':
    'You_cannot_use_that_password_Please_try_another_password',
  'Error signing up. Please try again.': 'Error_signing_up_Please_try_again',
  'Reset password link is expired': 'Reset_password_link_is_expired',
  'User does not exists': 'User_does_not_exists',
  'User already exists': 'User_already_exists',
  'Invalid Referrer Email': 'Invalid_Referrer_Email',
} as const;

export const getTranslatedError = (
  t: (key: string, defaultValue: string) => string,
  error: string,
): string => {
  // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly 'Incorrect email or password': "Incorrect_email_or_password"; readonly 'Failed to perform action, Please try after sometime': "Failed_to_perform_action_Please_try_after_sometime"; ... 13 more ...; readonly 'Invalid Referrer Email': "Invalid_Referrer_Email"; }'.
  const errorKey = ERROR_CODES_KEYS[error] || error;
  return t(errorKey, error);
};
